import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import {
  amenity_lifespan_uploads,
  get_lifespan_photo,
  manage_amenities_lifespan,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../api/constant";
import Button from "@mui/material/Button";

const AmenitiesLifespan = ({ role, userData }) => {
  const { t } = useTranslation();
  const iframeRef = React.useRef(null);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageData, setModalImageData] = useState(""); // State to hold image data for modal
  const [isImageModalOpen, setIsImageModalOpen] = useState(false); // State to control modal visibility

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [
    AmenityLifeSpanPhotoCommentError,
    setAmenityLifeSpanPhotoCommentError,
  ] = useState(false);
  const [amenityLifeSpanPhotoSubmit, setAmenityLifeSpanPhotoSubmit] = useState({
    amenities_id: "",
    amenities_sub_type_id: "",
    amenity_lifespan_photo: "",
    comment: "",
    UDISE_code: "",
  });
  const [amenityLifeSpanPhotoData, setAmenityLifeSpanPhotoData] = useState([]);

  const fetchApi = async () => {
    setIsLoading(true);

    const amenityLifeSpanData = await get_lifespan_photo(
      userData.data.UDISE_code
    );
    if (amenityLifeSpanData.status == "success") {
      setIsLoading(false);
      setAmenityLifeSpanPhotoData(amenityLifeSpanData.data.asset_images);
    } else {
      setIsLoading(false);
      setAmenityLifeSpanPhotoData([]);
    }

    const lifeSpandata = await manage_amenities_lifespan(
      userData.data.UDISE_code
    );
    if (lifeSpandata.status == "success") {
      setFilteredData(lifeSpandata.data.new_asset_query);
      setRows(lifeSpandata.data.new_asset_query);
      setIsLoading(false);
    } else {
      setFilteredData([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApi();
  }, []);

  const openImageModal = (imageData) => {
    setModalImageData(imageData); // Set the image data to display in the modal
    setIsImageModalOpen(true); // Open the modal
  };
  const closeImageModal = () => {
    setModalImageData(""); // Clear the image data when closing the modal
    setIsImageModalOpen(false); // Close the modal
  };

  const handleImageClick = (imageData) => {
    openImageModal(imageData); // Open the modal with the clicked image data
  };

  const openModal1 = (row) => {
    setAmenityLifeSpanPhotoSubmit({
      amenities_id: row.amenities_id,
      amenities_sub_type_id: row.amenities_sub_type_id,
      UDISE_code: userData.data.UDISE_code,
    });

    setIsModalOpen1(true);

    if (amenityLifeSpanPhotoSubmit.comment.trim() === "") {
      setAmenityLifeSpanPhotoCommentError(true);
      return;
    }
  };

  const closeModal1 = () => {
    setIsModalOpen1(false);
  };

  const submitModal = () => {
    setIsLoading(true);
    if (
      !amenityLifeSpanPhotoSubmit.amenity_lifespan_photo ||
      !amenityLifeSpanPhotoSubmit.comment
    ) {
      setIsLoading(false);
      toast.error("Please Select Photo/ Fill Comment first!");
      return;
    }

    const formData = new FormData();

    formData.append("amenities_id", amenityLifeSpanPhotoSubmit.amenities_id);
    formData.append(
      "amenities_sub_type_id",
      amenityLifeSpanPhotoSubmit.amenities_sub_type_id
    );
    formData.append("comment", amenityLifeSpanPhotoSubmit.comment);
    formData.append(
      amenityLifeSpanPhotoSubmit.amenities_id == 1
        ? "amenity_lifespan_photo_personal"
        : amenityLifeSpanPhotoSubmit.amenities_id == 2
        ? "amenity_lifespan_photo_common"
        : amenityLifeSpanPhotoSubmit.amenities_id == 3
        ? "amenity_lifespan_photo_infra"
        : amenityLifeSpanPhotoSubmit.amenities_id == 4
        ? "amenity_lifespan_photo_electronics"
        : amenityLifeSpanPhotoSubmit.amenities_id == 5
        ? "amenity_lifespan_photo_building_infra"
        : "amenity_lifespan_photo_furniture",
      amenityLifeSpanPhotoSubmit.amenity_lifespan_photo
    );
    formData.append("UDISE_code", amenityLifeSpanPhotoSubmit.UDISE_code);

    amenity_lifespan_uploads(formData).then((res) => {
      if (res.status == "success") {
        setIsLoading(false);
        toast.success(res.message);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setIsLoading(false);
        toast.error(res);
      }
    });
  };

  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        item.hostel_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.hostel_category
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (item.UDISE_code &&
          item.UDISE_code.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        item.school_catgegory.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No photo selected!");
      return;
    }

    const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;

    if (!allowedExtensions.test(file.name)) {
      toast.error("Invalid file type. Only JPG and PNG files are allowed.");
      event.target.value = "";
      return;
    }
    setAmenityLifeSpanPhotoSubmit((prevState) => ({
      ...prevState,
      amenity_lifespan_photo: file,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("Amenity Lifespan")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="col-md-2 ">
            <label htmlfor="title">{t("Academic Year")}</label>
            <select
              name="district" // value={AssetsType}
              className="common-input form-select"
            >
              <option value="" selected={true}>
                {t("2023-24")}
              </option>
            </select>
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Amenity Type")}</TableCell>
                  <TableCell align="left">{t("Amenity Sub Type")}</TableCell>
                  <TableCell align="center">{t("Lifespan (years)")}</TableCell>
                  <TableCell align="center">
                    {t("Remaining Lifespan (years)")}
                  </TableCell>
                  <TableCell align="center">{t("Amenity Condition")}</TableCell>
                </TableRow>
              </TableHead>

              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">{row.amenities_type}</TableCell>
                        <TableCell align="left">
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="center">{row.life_span}</TableCell>
                        <TableCell
                          align="center"
                          style={{
                            color:
                              row.remaining_life >= row.life_span * 0.5
                                ? "green"
                                : row.remaining_life >= row.life_span * 0.25
                                ? "orange"
                                : "red",
                          }}
                        >
                          {row.remaining_life}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          align="center"
                          style={{
                            align: "center",
                            padding: "1rem",
                            lineHeight: "1",
                          }}
                        >
                          {amenityLifeSpanPhotoData[index] ? (
                            <img
                              src={`data:image/png;base64,${amenityLifeSpanPhotoData[index].image}`}
                              className="border border-3"
                              alt="Checklist"
                              style={{
                                width: "50px",
                                borderRadius: "50%",
                                height: "50px",
                              }}
                              onClick={() =>
                                handleImageClick(
                                  amenityLifeSpanPhotoData[index].image
                                )
                              }
                            />
                          ) : (
                            <WallpaperIcon
                              style={{
                                width: "3.2rem",
                                height: "3.2rem",
                                position: "relative",
                                marginRight: 4,
                                background: "#fff",
                                color: "whitesmoke",
                              }}
                              onClick={openModal1}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
      <Modal
        open={isModalOpen1}
        onClose={closeModal1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "40rem",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={closeModal1}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "black",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t("Amenity Condition")}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}></Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <input
              type="file"
              name="photo_file"
              accept=".jpg, .jpeg, .png"
              className="form-control mb-4"
              onChange={handlePhotoChange}
            />

            <div className="">
              <label className="form-label">{t("Reason for Rejection")}</label>
              <input
                type="textbox"
                name="AmenityLifeSpanPhotoComment"
                value={amenityLifeSpanPhotoSubmit.comment}
                className={`form-control ${
                  AmenityLifeSpanPhotoCommentError ? "border-danger" : ""
                }`}
                onChange={(e) =>
                  setAmenityLifeSpanPhotoSubmit((prevState) => ({
                    ...prevState,
                    comment: e.target.value,
                  }))
                }
                onKeyUp={(e) => {
                  if (e.target.value.length >= 5) {
                    setAmenityLifeSpanPhotoCommentError(false);
                  }
                }}
                required
              />
              {AmenityLifeSpanPhotoCommentError && (
                <small className="text-danger">
                  {t("Comment for Amenity Lifespan is required!")}.
                </small>
              )}
            </div>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <button className="btn btn-success mx-3" onClick={submitModal}>
              {t("Submit")}
            </button>
            <button className="btn btn-secondary" onClick={closeModal1}>
              {t("Close")}
            </button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={isImageModalOpen}
        onClose={closeImageModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "fitContent",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {t("Image Preview")}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <img
              src={`data:image/png;base64,${modalImageData}`}
              alt="Preview"
              style={{ maxHeight: "80vh", maxWidth: "80vw" }}
            />
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button color="secondary" onClick={closeImageModal}>
              {t("Close")}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AmenitiesLifespan;
